import { Workbox } from 'workbox-window';
import { log } from '@atlassian/jira-common-util-logging';
import { ff } from '@atlassian/jira-feature-flagging';
import {
	PACKAGE_LOCATION,
	SERVICE_WORKER_RESOURCE_ENDPOINT,
	SERVICE_WORKER_SCOPE,
} from './common/constants';
import { logCurrentWorkerMetrics, attachMetricListeners } from './services/register';
import { destroyServiceWorker } from './services/unregister';
import { getPathname } from './services/util';

export type { ServiceWorkerInfoResponse } from './services/register';

let serviceWorker: Workbox | null = null;

export const getServiceWorker = (): Workbox | null => serviceWorker;

/**
 * Registers the service-worker, publishing information about the this Jira SPA registration's events
 * and the current controller service-worker as analytics events.
 */
export const runRegister = async (): Promise<void> => {
	const isInScope = getPathname().startsWith(SERVICE_WORKER_SCOPE);
	const startTime = performance.now();
	await logCurrentWorkerMetrics(startTime, isInScope);

	if (!isInScope) {
		return;
	}

	const workbox = new Workbox(SERVICE_WORKER_RESOURCE_ENDPOINT, {
		scope: SERVICE_WORKER_SCOPE,
	});
	attachMetricListeners(workbox, startTime);

	serviceWorker = workbox;
	await workbox.register({
		immediate: true,
	});
};

const startServiceWorker = () => {
	try {
		if (
			typeof navigator !== 'undefined' &&
			!__SERVER__ &&
			'serviceWorker' in navigator &&
			ff('jsw.perf.install-jira-service-worker')
		) {
			runRegister().catch((err) => {
				log.safeErrorWithoutCustomerData(PACKAGE_LOCATION, err);
			});
			return;
		}
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		log.safeErrorWithoutCustomerData(PACKAGE_LOCATION, err);
	}

	destroyServiceWorker();
};

export default startServiceWorker;
